import {
  parseUserFullName,
  renderWebComponent,
  string2obj,
  titleize
} from "../../../utils/utils";
import I18n from "i18n-js";


export class AddressComponent extends HTMLElement {
  props = {};

  static get observedAttributes() {
    return [ 'props' ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (newValue)
      this.props = string2obj(newValue);
    this.render();
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open'});
  }

  render() {
    const html = `              
      <span>
        ${
          parseUserFullName(this.props.address.first_name, this.props.address.last_name)
        }
      </span>
      ${
        this.props.address.co ?
          `<br/>
          <span>
            ${I18n.t('js.newUserAddressForm.co')} ${this.props.address.co}
          </span>`
        :
          ``
      }
      <br/>
      <span>
        ${
          titleize(this.props.address.street_square) + ' ' + this.props.address.number + (this.props.address.indoor ? (' ' + I18n.t('js.newUserAddressForm.indoor') + ' ' + this.props.address.indoor) : '')
        }
      </span>
      <br/>
      <span>
        ${
          this.props.address.cap + (this.props.address.city.toUpperCase() !== this.props.address.province.toUpperCase() ? ', ' + titleize(this.props.address.city) : '') + ' - ' + this.props.address.province.toUpperCase() + ' (' + this.props.address.country.toUpperCase() + ')'
        }
      </span>
      ${
        this.props.address.phone_number ?
          `<br/>
          <span>
            ${I18n.t('js.newUserAddressForm.phoneNumber')}: ${this.props.address.phone_number}
          </span>`
        :
          ``
      }
      ${
        this.props.address.email ?
          `<br/>
            <span>
              ${I18n.t('js.newUserAddressForm.email')}: ${this.props.address.email}
            </span>`
          :
          ``
      }
      ${
        this.props.note ?
          `<br/>
          <span>
            ${I18n.t('js.newUserAddressForm.noteForCourier')}: ${this.props.note}
          </span>`
        :
          ``
    }`

    renderWebComponent(html, this.shadowRoot);
  }
}

window.customElements.define("address-component", AddressComponent);